
import React, { useState, useEffect, useContext } from "react";


import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../../api/tmdbApi";

import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../../context/contentContext";
import SessionPopup from "../../pages/SessionPopup"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { keyActivate } from "../../utils/a11y";

let { lambda, appname } = window.app

const Subscriptions = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};
    const [toggle, setToggle] = useState(false);
    // const [data, setData] = useState([]);
    // const [userdata, setUserData] = useState([]);
    const [user, setUser] = useState("");
    const [editedData, setEditedData] = useState({}); // Holds the current editing plan
    // const [perpage, setPerpage] = useState(10);
    // const [arrow, setArrow] = useState(0);
    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    const [perpage, setPerpage] = useState(10);
    const [features, setFeatures] = useState([]);
    const [BtnLoader, setBtnLoader] = useState(false);
   // const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(10);
    const [subscriptionsData, setSubscriptionsData] = useState([]);
    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);
    const [errors, setErrors] = useState({});

const[image,setImg]=useState('')
    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum]= useState();
    // const [sortDirection, setSortDirection] = useState('asc');
         
useEffect(()=>{
    getSbscriptionsApi()
},[])
     

    let id = localStorage.getItem("userId");

    const [flag, setFlag] = useState(false);

    // const [isLoading, setIsLoading] = useState(false); 
    const {searchedFlag, setSearchedFlag,  isLoading, setIsLoading,userData,clientInfo, setUserData,GetClientDataContext, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch ,currentPage, setcurrentPage, data, setData,rowsPerPage, setRowsPerPage,currentPageNew, setCurrentPage,route, setRoute,usePrevious, setActiveMenuId,  GetTimeActivity} = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu==="User Management")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
    // // console.log('validate obj', validateObj)

    const prevRoute = usePrevious(route)
     useEffect(() => {
         if(prevRoute !== undefined && prevRoute!=route){
             setCurrentPage(1)
             setRowsPerPage(15)
             setSearchedFlag(false);
             setUserSearch("")
         }
     }, [prevRoute]);
     useEffect(() => {
        const token = localStorage.getItem("token");
      
        if (!token) {
          navigate("/signin");
          return;
        }
      
        // Skip if clientInfo is still empty
        if (!clientInfo?.subscriptionPayment) return;
      
        if (clientInfo.subscriptionPayment !== "PAYMENT SUCCESS") {
          navigate("/signin");
        }
      }, [clientInfo, navigate]);
     useEffect(() => {
        if (toastMessage) {
          toast.success(toastMessage, {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
    
          // Clear the message after showing to prevent re-triggering
          setToastMessage("");
        }
      }, [toastMessage]);

     const getSbscriptionsApi = (e) => {
        axios({
            method: 'GET',
            url: lambda + '/getSubscriptions?appname=' + appname ,
        })
            .then(function (response) {
                if (response?.data?.result==="Invalid token or Expired") {
                    // setShowSessionPopupup(true)
                } else {
                    setSubscriptionsData(response?.data?.result);
                    // setSelectedPlan(response?.data?.result?.[0])
                          setEditedData([])
                    
                }
    
            }).catch((err) => {
                // console.log('error', err);
              
            });
    }
    
    // console.log("subscripionData------------------------->",subscriptionsData)
     useEffect(() => {

       if (window.site === undefined) {
           setTimeout(() => {
               if (window.site && window.site.common && window.site.common.imageCloudfront) {
                   setImg(window.site.common.imageCloudfront)
               }
           }, 1000);
       }
       if (window.site && window.site.common && window.site.common.imageCloudfront) {
           setImg(window.site.common.imageCloudfront)
       }
   
   
   }, [window.site]);

   const validateInputs = () => {
    const newErrors = {};

    // Validate Features Dynamically
    features.forEach(feature => {
        // Only validate if the object has a `label`
        if (feature?.label) {
            const featureValue = feature?.value;
    
            // Check if value is empty
            if (featureValue === '') {
                newErrors[feature.feature] = `${feature.label} is required. Please enter a value.`;
            }
            // Check if value is 0 or negative
            else if (typeof featureValue === 'number' && featureValue <= 0) {
                newErrors[feature.feature] = `${feature.label} must be a positive number greater than zero.`;
            }
        }
    });
    if (editedData?.planname === 'Basic Plan') {
        const monthlyValue = Number(editedData?.monthly);
        const yearlyValue = Number(editedData?.yearly);
    
        if (editedData?.monthly === '' && editedData?.yearly === '') {
            newErrors['monthly_yearly'] = 'Monthly and Yearly values are required. Please enter valid numbers.';
        } else if (monthlyValue < 0 && yearlyValue < 0) {
            newErrors['monthly_yearly'] = 'Monthly and Yearly values cannot be negative. Please enter a positive number or zero.';
        } else if (editedData?.monthly === '') {
            newErrors['monthly_yearly'] = 'Monthly value is required. Please enter a valid number.';
        } else if (editedData?.yearly === '') {
            newErrors['monthly_yearly'] = 'Yearly value is required. Please enter a valid number.';
        } else if (monthlyValue < 0) {
            newErrors['monthly_yearly'] = 'Monthly value cannot be negative. Please enter a positive number or zero.';
        } else if (yearlyValue < 0) {
            newErrors['monthly_yearly'] = 'Yearly value cannot be negative. Please enter a positive number or zero.';
        }
    } else if (editedData?.planname === 'Premium Plan' || editedData?.planname === 'Pro Plan') {
        const monthlyValue = Number(editedData?.monthly);
        const yearlyValue = Number(editedData?.yearly);
    
        if (editedData?.monthly === '' && editedData?.yearly === '') {
            newErrors['monthly_yearly'] = 'Monthly and Yearly values are required. Please enter valid numbers greater than zero.';
        } else if (monthlyValue <= 0 && yearlyValue <= 0) {
            newErrors['monthly_yearly'] = 'Monthly and Yearly values must be positive numbers greater than zero.';
        } else if (editedData?.monthly === '') {
            newErrors['monthly_yearly'] = 'Monthly value is required. Please enter a positive number greater than zero.';
        } else if (editedData?.yearly === '') {
            newErrors['monthly_yearly'] = 'Yearly value is required. Please enter a positive number greater than zero.';
        } else if (monthlyValue <= 0) {
            newErrors['monthly_yearly'] = 'Monthly value must be a positive number greater than zero.';
        } else if (yearlyValue <= 0) {
            newErrors['monthly_yearly'] = 'Yearly value must be a positive number greater than zero.';
        }
    }
    
    
    // Validate Description
    if (!editedData?.tagline?.trim() || editedData?.tagline.length >= 50) {
        newErrors['tagline'] = 'Description must be less than 50 characters long.';
    }
    

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
};
// console.log("erors----------------------------->",errors)

const handleSave = () => {
    if (validateInputs()) {
        // console.log("Validation passed. You can proceed with saving.");
      
        GetTimeActivity()   
setBtnLoader(true)
    
            const token = localStorage.getItem("token")
            let payload = {}
            payload = {
               
               ...editedData
              
            }
    
            delete payload._id;
            delete payload.planid;
    
            axios({
                method: 'POST',
                url: lambda + '/updateSubscriptions?appname=' + appname + '&planid=' + editedData?.planid,
                data: payload,
            })
                .then(function (response) {
                    if (response) {
                        if (response?.result==="Invalid token or Expired") {
                            // setShowSessionPopupup(true)
                        }  else {
                          setBtnLoader(false)
                            getSbscriptionsApi()
                            // setIsLoading(false);
                            // setUpdateSuccess(true)
                            setToastMessage("Plan Updated Successfully")
                        
                   
                     
                            // setToastType("success")
                            // GetClientDataContext()
                        }
                    }
    
                });
    
        // Add your save logic here.
    } else {
        // console.log("Validation failed. Please correct the errors.");
    }
};



    //  // console.log('prevRoute--->',prevRoute)
    //  // console.log('currentRoute--->',route)
    const keyForRerender = `${rowsPerPage}_${data?.length}`;
     const columns = [
 
         {
             name: 'Name',
             selector: row => row?.name ?? "",
             sortable: true,
         },
         {
             name: 'User Type',
             selector: row => row?.type ?? "",
             sortable: true,
         },
         {
             name: 'Email id',
             selector: row => row?.emailid ?? "",
             sortable: true,
         },
         {
             name: 'Phone Number',
             selector: row => row?.phone ?? "",
             sortable: true,
         },
         {
            name: 'Status',
            selector: row => row?.status ?? "",
            sortable: true,
        },
        
 
         {
             name: <>{(subValDashboard && subValDashboard.view && subValDashboard.view.display === true) || (subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true) ? 'Actions' : null}</>,
             cell: (props) => 
            //   {
                subValDashboard && subValDashboard.view && subValDashboard.edit && (subValDashboard.view.display === true || subValDashboard.edit.display === true) &&
            <div className="d-flex">
            {subValDashboard && subValDashboard.view && subValDashboard.view.display === true &&
                <a onClick={e => handleViewUser(e, props.userid)} onKeyDown={keyActivate(e => handleViewUser(e, props.userid))}
                    className={`${subValDashboard && subValDashboard.view && subValDashboard.view.enable === false ? 'pe-none' : ''} text-success action-button`}><i
                        className="mdi mdi-eye font-size-18"></i></a>}
            {subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true && <>
                {props.userid === id ? <a
                    className={`${subValDashboard && subValDashboard.edit && subValDashboard.edit.enable === false ? 'pe-none' : ''} text-danger action-button`}><i
                        className="mdi mdi-pencil font-size-18"></i></a> : <a onClick={e => handleEditUser(e, props.userid)} onKeyDown={keyActivate(e => handleEditUser(e, props.userid))}
                            className={`${subValDashboard && subValDashboard.edit && subValDashboard.edit.enable === false ? 'pe-none' : ''} text-danger action-button`}><i
                                className="mdi mdi-pencil font-size-18"></i></a>}</>}
        </div>
            //  }
             ,
             ignoreRowClick: true,
             allowOverflow: true,
             button: true,
         },
     ];
 
     const handlePageChange = (page) => {
        GetTimeActivity()   
         setCurrentPage(page);
       };
     
       const handlePerRowsChange = (newPerPage) => {
        GetTimeActivity()   
         setRowsPerPage(newPerPage);
       };
     
// // console.log('datattatatattatat',data)
    useEffect(() => {
        setRoute("user")
       //  GetClientDataContext()
        setActiveMenuId(200005)
        setActiveMenuObj({
            "Client Management": false,
            "Contact Management":false,
            "Reports": false
        })
       //  // userActivity();
    }, []);
//      const userActivity = () => {
//          let path = window.location.pathname.split("/");
//          const pageName = path[path.length - 1];
//          var presentTime = moment();
//          let payload;

//          payload = {
//              "userid": localStorage.getItem("userId"),
//              "pagename": pageName,
//              "pageurl": window.location.href,
//              "starttime": presentTime,
//              "useragent": JSON.parse(localStorage.getItem("loc"))

//          };


//     const previousId = localStorage.getItem("previousid");
//  const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


//          axios({
//              method: 'POST',
//              url: urlLink,
//              data: payload
//          })
//              .then(function (response) {
//                  if (response?.data?.statusCode === 200) {
//                      localStorage.setItem("previousid", response?.data?.result)
//                  }
//              });
//      }
    const GetUserData = async () => {
        GetTimeActivity()   
        try {

            const response = await tmdbApi.getUserData({});

            if (response?.statusCode === 200) {

                setUserData(response?.result?.[0]);
                localStorage.setItem("ClientName", response?.result?.[0]?.name)
                localStorage.setItem("ClientType", response?.result?.[0]?.type)
                let userArr = response?.result?.[0]?.permissions

                const obj = userArr.reduce((acc, item) => {
                    if (item.submenus) acc[item.menu] = false;
                    return acc;
                }, {});
                // // console.log('objjjjjjjj--->',obj)
                // setActiveMenuObj(obj)

                // console.log('response?.result?.[0]', response?.result?.[0])
            }
        } catch {
            // console.log("error");
        }
    };
 

    // useEffect(() => {
    //     if (!localStorage.getItem("token")) {
    //         navigate("/");
    //     }
      
    // }, []);


    useEffect(() => {
        const token = localStorage.getItem("token");
      
        if (!token) {
          navigate("/signin");
          return;
        }
      
        // Skip if clientInfo is still empty
        if (!clientInfo?.subscriptionPayment) return;
      
        if (clientInfo.subscriptionPayment !== "PAYMENT SUCCESS") {
          navigate("/signin");
        }
      }, [clientInfo, navigate]);
   //  useEffect(() => {
      

   //      // console.log("trueeeeeeeeee",searchedFlag);
   //      if (searchedFlag) { 
   //          // console.log("came") 
   //          handleSearch();
   //      } else {
   //          // console.log("called get all deals") 
   //          User();
   //      }

   //  }, [searchedFlag]);

    const PageLoad = (e) => {
        const pagevalue = e.target.value;
        //setPerpage(pagevalue);
        setitemsPerPage(pagevalue);
        setcurrentPage(1);
        setmaxPageNumberLimit(5);
        setminPageNumberLimit(0);

    }


    const User = (e) => {
        GetTimeActivity()   
        setIsLoading(true)
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/users?appname=' + appname + "&token=" + token,
        })
            .then(function (response) {
                // console.log("response", response);
                if (response?.data?.result==="Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                setUser(response?.data?.result);
                setData(response?.data?.result?.data);
                global.exportExcelData = response?.data?.result?.data
                      


                setIsLoading(false);
                setUserSearch("");
                setSearchedFlag(false);
                }
            }).catch((err) => {
                // console.log('error', err);
                setTableErrMsg(true)
                setIsLoading(false);
            });
    }



  

    const handleSearch = (e,flagggg) => {
        GetTimeActivity()   
        if(flagggg){
            setcurrentPage(1);
          } 
        setmaxPageNumberLimit(5);
        setminPageNumberLimit(0);
        if(flagggg === "normalsearch"){
            setSearchedFlag(true)
       }
        setFlag(true)
        if (usersearch === "") {
            User();
        }
        else {
            setIsLoading(true)
            const token = localStorage.getItem("token")
            axios({
                method: 'GET',
                url: lambda + '/users?appname=' + appname + "&search=" + usersearch + "&token=" + token,
            })
                .then(function (response) {
                    if (response?.data?.result==="Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else {
                        // console.log("response", response);
                        setUser(response?.data?.result);
                        setData(response?.data?.result?.data);
                        global.exportExcelData = response?.data?.result?.data
                      


                        setIsLoading(false)
                    }
                }).catch((err) => {
                    // console.log('error', err);
                    setTableErrMsg(true)
                    setIsLoading(false);
                });
        }
    }

   


   //  const handleKeypress = (e) => {
   //      //it triggers by pressing the enter key
   //      GetTimeActivity()   
   //      if ((e.key === "Enter")) {
   //          setTimeout(function () {
   //              handleSearch();
   //          }, 1000);
   //      }
   //  };
    const handleAddSubscription = (e) => {
        GetTimeActivity()   
        navigate("/addsubscription");
    }

    const handleEditUser = (e, paramuserid) => {
        // console.log('paramuserid',paramuserid)
        GetTimeActivity()   
        navigate("/edituser/" + paramuserid);
    }
    const handleViewUser = (e, paramuserid) => {
        GetTimeActivity()   
        // console.log('paramuserid',paramuserid)

        navigate("/viewuser/" + paramuserid);
    }

    const clearSearch = () => {
        GetTimeActivity()   
        setUserSearch("");
        User();
        setcurrentPage(1);
    }

    const customNoRecords = () => {
        return(
            
            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No users were found for the searched keyword</p>
                </div> </div>
        )
    }
    const handleStatusChange = (e, item) => {
        const isChecked = e.target.checked;
    
        setEditedData(prevData => ({
            ...prevData,
            status: isChecked ? "ACTIVE" : "INACTIVE"
        }));
    
        // console.log(`Status changed to: ${isChecked ? "ACTIVE" : "INACTIVE"}`);
    };
    
    const handleEdit=(id)=>{
        // console.log("IdDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD",id)
        const filterData = subscriptionsData?.find((item) => item?.planid === id);
        // console.log("filterDatatatata", filterData);  // This will print the object directly
        setEditedData(filterData)
        setFeatures(filterData?.features)
        setErrors({})
    }
    // console.log("features----------------------->",features)
    const handleChange = (event, id) => {
        const { name, value } = event.target;
    // console.log("editedDatattata---->",editedData?.planid)
    // console.log("Iddddddddddddddddddddddddddd",id)
      
            setEditedData((prevData) => ({
                ...prevData,
                [name]: Number(value) || value,  // Update the edited field dynamically; if it's a number, store it as a number
            }));
            setErrors(prevErrors => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name]; // Remove the error for the current field only
                return updatedErrors;
            });
    };
    const handleInputChange = (e) => {
        const { name, value, type } = e.target;
        let updatedValue = value;
    
        // Prevent negative values
        if (Number(value) < 0) return;
    
        // If value is '0', set it as an empty string
        if (value === '0') {
            updatedValue = '';
        } else if (/^[1-9]\d*$/.test(value)) {  // If the value is a valid number without leading zeros
            updatedValue = Number(value);  // Convert to number
        }
    
        // Update the state array
        const updatedFeatures = features.map(feature =>
            feature.feature === name ? { ...feature, value: updatedValue } : feature
        );
    
        setFeatures(updatedFeatures);
        setEditedData(prevData => ({
            ...prevData,
            features: updatedFeatures,
        }));
    
        // Clear error for this field
        setErrors(prevErrors => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });
    };
    
    
    // console.log("editedData---------------------------->",editedData)

    
    const handleExport = () => {
     
              // let k = defaultData || exportExcelData
          const modifiedArray = global.exportExcelData.map(( each,i) => ({
                "S.NO":i+1,
                "NAME": each?.name ?? "",
                "USER TYPE": each?.type ?? "",
                "EMAIL ID":   typeof each?.emailid === "object" && each?.emailid !== null && each?.emailid.length > 1 ? each?.emailid.join(', ') : each?.emailid ?? "",
                "PHONE NUMBER": each?.phone ?? "" ,
                "STATUS": each?.status?? "",
              
              }));
         
            exportToExcel(modifiedArray, "data");
           
        }
        function exportToExcel(jsonData, fileName) {
            delete jsonData['_id'];
            const worksheet = XLSX.utils.json_to_sheet(jsonData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const data1 = new Blob([excelBuffer], { type: 'application/octet-stream' });
            //FileSaver.saveAs(data, `${fileName}.xlsx`);
            FileSaver.saveAs(data1, `UsersData.xlsx`);
            // console.log('data22222--->',data)
        }
        const customSort = (rows, selector, direction) => {
            const sortedData = rows.slice().sort((rowA, rowB) => {
              // use the selector function to resolve your field names by passing the sort comparators
              // const aField = selector(rowA);
        const aField = String(selector(rowA)).toLowerCase();

              //  const bField = selector(rowB);
          const bField = String(selector(rowB)).toLowerCase();
          
              let comparison = 0;
          
              if (aField > bField) {
                comparison = 1;
              } else if (aField < bField) {
                comparison = -1;
              }
          
              return direction === 'desc' ? comparison * -1 : comparison;
            });
          
            // Log the sorted data to the console
            // setSortedRecomData(sortedData)
            global.exportExcelData = sortedData
            // // console.log('Sorted Data------>:', sortedData);
          
            return sortedData;
          };    
    // // console.log("showSessionPopupup",showSessionPopupup)
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                {/* Start right Content here  */}
              
                    <div className="main-content user-management">

                        <div className="page-content">
                            <div className="container-fluid">



                                <div className="row  breadcrumb">
                                    <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                             <div className="flex-grow-1">
                                                 <h4 className="mb-2 card-title">SUBSCRIPTIONS</h4>
                                             </div>
                                             {/* {subValDashboard && subValDashboard.Add && subValDashboard.Add.display === true &&
                                                 <div>
                                                 </div>} */}
                                                 {/* <button className="fill-btn-style" onClick={handleAddSubscription} disabled={subValDashboard && subValDashboard.Add && subValDashboard.Add.enable === false}>CREATE</button> */}
                                         </div>
                                    </div>
                                </div>

                                <div className="row table-data">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body">
                            {/* Here Start Subscription plan */}
                            <div className="subscription-plan">
                                            {/* <h4 className="mb-2 card-title">Upgrade</h4>
                                            <p className="card-desc mb-4">Upgrade to get more out of subscription</p> */}
                                            {/* Showing Subscriptions Page */}
                                            <div className="row">
                                             {/* basic plan */}
                                             {subscriptionsData?.map((item)=>{
                                                return(
                                                    <div className="col-md-4" id="subscription-card">
                                                    <div className="store_block subscription-wrapper">
                                                        <div className="d-flex sub-header" id="subcription-plan-name">
                                                        <h3 className="sm-heading">{item?.planname}</h3>
                                                        <div className="input-field switch-buttons d-flex align-items-center" id="subcription-plan-status1">
                                                        <label className="col-form-label p-0 me-2">Active</label>
                                                        <label className="switch disable mb-0">
                                                        <input type="checkbox" id="plan-status-checkbox" checked={editedData?.planid === item?.planid ? editedData?.status === "ACTIVE" : item?.status === "ACTIVE"}
    onChange={(e) => handleStatusChange(e, item)}
    disabled={item?.planid !== editedData?.planid}
/>
                                                        <span className="slider round"></span>
                                                        </label>
                                                        </div>

                                                        <div className="d-flex edit-delete-option" id="subcription-edit-icon" onClick={()=>handleEdit(item?.planid)} onKeyDown={keyActivate(()=>handleEdit(item?.planid))}>
                                                        <span className="material-symbols-outlined edit-icon">edit</span>
                                                        </div>
                                                        </div>
                                                        <div>
                                                        {/* PLAN PRICE */}
                                                        <div className="input-group mt-3 mb-3" id="subcription-plan-price">
                                                        <label className="form_label label-width">PLAN PRICE<span className="required">*</span></label>
                                                        <div className="d-flex gap-3 input-flex">
                                                        <div className="input-group input-width-1">
                                                        <input className="form-control input-border" placeholder="$00"   onKeyDown={(e) => {
        // Prevent decrement when using arrow keys
        if (e.key === 'ArrowDown') {
            e.preventDefault();
        }
    }}     value={editedData?.planid === item?.planid ? editedData?.monthly : item?.monthly}  type="number" id="subcription-per-monthly" name="monthly" disabled={item?.planid!==editedData?.planid} onChange={handleChange}/>
                                                        {/* {item?.planid === editedData?.planid && errors['monthly'] && ( // Displaying errors only if IDs match
            <div className="error-message" style={{ color: 'red', marginTop: '5px' }}>
                {errors['monthly']}
            </div>
        )} */}
                                                        <span className="input-group-text month-text">Per Month</span>
                                                        </div>
                                                        <div className="input-group input-width-2">
                                                        <input className="form-control input-border" id="subcription-per-year" placeholder="$00" type="number" value={editedData?.planid === item?.planid ? editedData?.yearly : item?.yearly}   onKeyDown={(e) => {
        // Prevent decrement when using arrow keys
        if (e.key === 'ArrowDown') {
            e.preventDefault();
        }
    }} name="yearly" disabled={item?.planid!==editedData?.planid} onChange={handleChange}/>
                                                        {/* {item?.planid === editedData?.planid && errors['yearly'] && ( // Displaying errors only if IDs match
            <div className="error-message" style={{ color: 'red', marginTop: '5px' }}>
                {errors['yearly']}
            </div>
        )} */}
                                                        <span className="input-group-text month-text">Per Year</span>
                                                        </div>
                                                        </div>
                                                        </div>
                                                        {item?.planid === editedData?.planid && errors['monthly_yearly'] && ( // Displaying errors only if IDs match
            <span className="error-message" style={{ color: "red", margin: "0px", fontSize: "10px",}}>
  {errors['monthly_yearly']}
</span>
        )}


                                                        {/* PLAN DESCRIPTION */}
                                                        <div className="input-group mb-1" id="subcription-plan-description">
                                                        <label className="form_label">PLAN DESCRIPTION<span className="required">*</span><br /><span className="label-desc">Enter description without exceeding 50 letters</span>
                                                        </label>
                                                        </div>
                                                        <input className="form-control" placeholder="Enter Plan Description" name="tagline" value={editedData?.planid === item?.planid ? editedData?.tagline : item?.tagline} onChange={handleChange} style={{ height: "50px" }}  disabled={item?.planid!==editedData?.planid}/>
                                                        {item?.planid === editedData?.planid && errors['tagline'] && ( // Displaying errors only if IDs match
            <span className="error-message" style={{ color: "red", margin: "0px", fontSize: "10px",}}>
  {errors['tagline']}
</span>
        )}
                                                        </div>

                                                        <div className="sub-section">
                                                        {/* Brand Manager */}
                                                        {(() => {
                                                             const filteredFeatures = item?.features.filter(f => f.label); // Features with 'label'
                                                             const moreFeatures = item?.features.filter(f => !f.label); // Features without 'label'
    return (
        <>
           {filteredFeatures?.map((feature, index) => (
    <div key={index}>
        <div className="input-group mt-3">
            <label className="form_label">
                {feature?.label}<span className="required">*</span>
            </label>
        </div>
        <input 
            className="form-control"
            placeholder={`Enter ${feature?.label}`}
            type="number"
            value={editedData?.planid === item?.planid 
                ? features.find(f => f.feature === feature.feature)?.value ?? feature?.value
                : feature?.value
            }
            name={feature?.feature}
            onChange={handleInputChange}
      
            disabled={item?.planid!==editedData?.planid}

        />
         {item?.planid === editedData?.planid && errors[feature.feature] && ( // Displaying errors only if IDs match
            <span className="error-message" style={{ color: "red", margin: "0px", fontSize: "10px",}}>
  {errors[feature.feature]}
</span>
        )}
    </div>
))}

{moreFeatures.length > 0 && (
    <>
        <div className="input-group mt-3" id="subcription-more-features">
            <label className="form_label">
                MORE FEATURES<span className="label-desc"> (Optional)</span>
            </label>
        </div>
        {moreFeatures.map((feature, index) => (
            <div key={index} className="input-group mb-2 input-style-flex">
                <input 
                    className="form-control"
                    type="text"
                    onKeyDown={(e) => {
        // Prevent decrement when using arrow keys
        if (e.key === 'ArrowDown') {
            e.preventDefault();
        }
    }}
                    value={editedData?.planid === item?.planid 
                        ? features.find(f => f.feature === feature.feature)?.value ?? feature?.value
                        : feature?.value
                    }
                    name={feature?.feature}
                    onChange={handleInputChange}
                    disabled={item?.planid!==editedData?.planid}  // Disable if features array is empty

                />
            </div>
        ))}
    </>
)}

        </>
    );
})()}
                                                      
                                                        {/* Store Manager */}
                                                     
                                                        
                                                        {/* Buttons */}
                                                        <div className="mt-3 d-flex justify-content-start">
                                                            <button className="fill-btn-style me-2" id="subcription-save"  disabled={item?.planid!==editedData?.planid} onClick={handleSave}>{item.planid === editedData?.planid && BtnLoader ? (<img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" />) : null}SAVE</button>
                                                        </div>

                                                        </div>
                                                        
                                                    </div>
                                            </div>
                                                )
})}
                                           
                                           
                                            </div>
                            </div>
                            {/* Here stop subscription plan */}
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>

                        <SweetAlert show={tableErrMsg}
                         custom
                         confirmBtnText="ok"
                         confirmBtnBsStyle="primary"
                         title={"Something went wrong. Please reload again."}
                         onConfirm={e => setTableErrMsg(false)}
                     >
                     </SweetAlert>
                        <Footer />

                    </div>
             


            </div>
            <ToastContainer
               id="toastContainer"
               position="bottom-center"
               autoClose={3000}
               hideProgressBar={false}
               newestOnTop={false}
               closeOnClick
               rtl={false}
               pauseOnFocusLoss
               draggable
               pauseOnHover={false}
               theme="light"
             />
        </>
    );
};

export default Subscriptions;
